import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    // marginTop: 16
    marginTop: -8
  });
  export const categoryRow = (selected: boolean) =>
    css({
      width: 'calc(100% + 16px)',
      padding: 8,
      marginRight: '-8px',
      marginLeft: '-8px',
      fontWeight: selected ? 500 : undefined,
      transition: animationTransition('background-color'),
      ':hover': {
        backgroundColor: '#FAFAFA',
        ' svg': {
          visibility: 'visible'
        }
      }
    });

  export const categoryButton = css({
    fontSize: '14px',
    color: '#484848',
    cursor: 'pointer',
    textAlign: 'left',
    background: 'none',
    borderStyle: 'none',
    padding: '0',
    font: 'inherit',
    outline: 'inherit'
  });

  export const themeButton = css({
    color: 'inherit',
    cursor: 'pointer',
    textAlign: 'left',
    background: 'none',
    borderStyle: 'none',
    padding: '0',
    margin: 8,
    font: 'inherit',
    outline: 'inherit',
    position: 'relative',
    boxShadow: '0px 1px 5px rgba(0,0,0,0.1)'
  });

  export const themeItem = css({
    margin: 8
  });

  export const themeContainer = css({
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 16
  });

  // 574 x 900
  export const themeOption = (url: string | null, isBlank = false) =>
    css(
      {
        backgroundColor: 'white',
        border: isBlank ? '1px solid #333' : undefined,
        height: 150,
        width: 574 / (900 / 150)
      },
      url
        ? {
            backgroundImage: `url("${url}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }
        : undefined
    );

  export const selectedCategoryContainer = css({
    display: 'flex',
    alignItems: 'center'
  });
  export const categoryChevron = css({
    height: '15px',
    marginRight: '16px',
    ' svg': {
      height: '100%',
      width: 15,
      transform: 'rotate(90deg)'
    }
  });
  export const selectedCategory = css({
    ...getInterUIDynamicMetricCssObject(15)
  });

  export const categoryOptionChevron = css({
    height: 15,
    width: 15,
    transform: 'rotate(-90deg)',
    visibility: 'hidden',
    backgroundColor: 'transparent',
    transition: animationTransition('background-color')
  });

  export const categoryOptionContainer = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...getInterUIDynamicMetricCssObject(15)
  });

  export const currentBadge = css({
    position: 'absolute',
    bottom: '8px',
    height: '20px',
    backgroundColor: 'rgba(0,0,0,.6)',
    width: 'calc(100% - 16px)',
    left: '50%',
    transform: 'translateX(-50%)',
    color: 'white',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    letterSpacing: '.2px',
    ...getInterUIDynamicMetricCssObject(10)
  });
}
